// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Toggle_wrapper__LU0Ri","label":"Toggle_label__1Oh7x","preLabel":"Toggle_preLabel__2zcLF","checkbox":"Toggle_checkbox__3n7jp","toggle":"Toggle_toggle__Z70-j"};